import { ComponentType, useCallback } from 'react';

import { VisitPatient } from '@dreryk/egabinet-visit-frontend-api';

import { ActionBar, PersonalInjuryIcon, useHistoryPushWithBackAction } from '@dreryk/react-components';

import { visitPaths } from '~libs.desktop.shared.paths';

import { checkIfPatientIdentifiesWithPESEL } from '../../common/common.utils';
import { medicalDevicesTranslationKeys } from '../../features/medicalDevices/translations';

import { VisitActionBarOrder } from './VisitActionBar';

type WithCheckIfPatientIdentifiesWithPESELProps = {
   readonly patient: VisitPatient;
};

const withCheckIfPatientIdentifiesWithPESEL = (Component: ComponentType<GoToMedicalDevicesActionProps>) => (
   props: GoToMedicalDevicesActionProps & WithCheckIfPatientIdentifiesWithPESELProps
): JSX.Element | null => {
   if (!checkIfPatientIdentifiesWithPESEL(props.patient.referenceIdentifier)) {
      return null;
   }

   return <Component {...props} />;
};

type GoToMedicalDevicesActionProps = {
   readonly visitId: number;
};

export const GoToMedicalDevicesAction = withCheckIfPatientIdentifiesWithPESEL(
   (props: GoToMedicalDevicesActionProps): JSX.Element => {
      const push = useHistoryPushWithBackAction(false);

      const goToMedicalDevices = useCallback(
         (): void =>
            push(
               visitPaths.getMedicalDevicesPath({
                  params: {
                     visitId: props.visitId,
                  },
               }),
               {
                  label: medicalDevicesTranslationKeys.goBackToVisit,
               }
            ),
         [push, props.visitId]
      );

      return (
         <ActionBar.OptionalLink
            testId={'goToMedicalDevices'}
            icon={<PersonalInjuryIcon />}
            label={medicalDevicesTranslationKeys.linkName}
            onClick={goToMedicalDevices}
            order={VisitActionBarOrder.MedicalDevices}
         />
      );
   }
);
